/**
 * Remove espaços extras nas bordas e colapsa espaços internos duplicados.
 */
export const normalizeLabel = (value: string): string => value.trim().replace(/\s+/g, ' ');

/**
 * Deixa a primeira letra de cada palavra maiúscula (para exibição de labels
 * que vieram de texto livre digitado pelo usuário).
 */
export const titleCase = (value: string): string =>
  normalizeLabel(value)
    .toLowerCase()
    .replace(/(^|\s)\p{L}/gu, (m) => m.toUpperCase());

/**
 * Divide um texto livre de personagens (ex: "Mickey, Minnie e Pateta") em
 * uma lista de nomes individuais normalizados.
 */
export const splitCharacterNames = (value: string | undefined | null): string[] => {
  if (!value) return [];
  return value
    .split(/[,;/]| e | com /gi)
    .map((v) => normalizeLabel(v))
    .filter(Boolean);
};
